import update from '../update';
import { asObject, batchUpdateAsObjects } from '../../../shared/utils';
import {
  ADD_FUNDS_REQUESTED,
  FUNDS_ADDED,
  FUNDS_FAILED_TO_ADD,
  FUNDS_TRANSFER_REQUESTED,
  FUNDS_TRANSFERRED,
  FUNDS_FAILED_TO_TRANSFER,
  TRANSFER_HISTORY_REQUESTED,
  TRANSFER_HISTORY_LOADED,
  TRANSFER_HISTORY_FAILED_TO_LOAD,
  LIST_OF_ACCOUNTS_REQUESTED,
  LIST_OF_ACCOUNTS_LOADED,
  LIST_OF_ACCOUNTS_FAILED_TO_LOAD
} from './constants';

const initialState = {
  accounts:{}
};

export default function(state=initialState,action){
  switch(action.type){

  case TRANSFER_HISTORY_LOADED:
    return update(state,{
      accounts:{
        $deepMerge:asObject([action.payload],'accountId')
      }
    });

  default:
    return update(state,{});
  }
}


// WEBPACK FOOTER //
// ./src/shared/redux/accounting/reducer.js